import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatsInsideSection() {
  const items = ['Guía descargable en PDF', 'Explicación del error que comete la mayoría de candidatos', 'Las 3 razones clave para hacer preguntas', 'Banco de preguntas estratégicas listas para usar', 'Ejemplos de preguntas sobre retos, cultura, liderazgo y objetivos', 'Recomendaciones sobre cuándo hacer preguntas', 'Método para escuchar y adaptar tu mensaje de valor', 'Consejos para mostrar interés, diferenciarte y vender tu perfil'];
  return <section id="whats-inside" className="py-20 lg:py-24 bg-lightGray px-4 sm:px-6 lg:px-8" data-id="element-170">
      <div className="max-w-7xl mx-auto" data-id="element-171">
        <FadeIn data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-16 text-center tracking-tight" data-id="element-173">
            Qué incluye el PDF
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto" data-id="element-174">
          <FadeIn direction="up" data-id="element-175">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-gray-200" data-id="element-176">
              <ul className="space-y-5" data-id="element-177">
                {items.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-178">
                    <CheckCircle2 className="w-6 h-6 text-emerald flex-shrink-0 mt-0.5" data-id="element-179" />
                    <span className="text-navy font-medium text-lg" data-id="element-180">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}